import { AutogenModelCarrierPlanLookup, AutogenRowCarrierPlanLookup } from "./autogen/AutogenModelCarrierPlanLookup";

export class ModelCarrierPlanLookup extends AutogenModelCarrierPlanLookup<RowCarrierPlanLookup> {
	constructor() {
		super(RowCarrierPlanLookup);
	}
}

export class RowCarrierPlanLookup extends AutogenRowCarrierPlanLookup {
}